export default [
  {
      text: 'Joining an online food delivery merchant has many benefits.',
      title: 'Why you should Sign Up as an airasia food Merchant Malaysia.'
    },
    {
      text: 'You will become a member of a large community of restaurant partners who want to access a wider customer base with online sales. Reach a larger audience with wider visibility on the food ordering platform.',
      title: 'Reach Out to a Bigger Audience.'
    },
    {
      text: 'An online store helps you get started selling your products while you work your way up to eventually establish your own brand and physical store.',
      title: 'Establish an Online Store'
    },
    {
      text: 'By partnering with an online food ordering platform, you will enjoy the convenience of a delivery service. The platform will arrange for the delivery service for you at a minimum price.',
      title: 'Enjoy Delivery Service'
    },
    {
      text: 'Joining as a restaurant partner helps you understand what works best for you as a merchant. You will then be able to manage your time, your merchandise, your accounts and customer service better.',
      title: 'Data Tracking'
    },
    {
      title:'Increase Your Income',
      text:'Becoming an online food restaurant business partner can help you achieve your financial targets faster. You will be able to make better sales from existing, returning and new customers. This will see your profits increase. ',
},
]
